import React, { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import { DownloadClientsDataInExcel } from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import DragDrop from "../DragDrop/DragDrop";
import { showErrorMessage } from "../Shared/Toast";
function AddressUnit() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);

  const [addressunitData, setAddressUnit] = useState<any>([]);
  const [totalData, setTotalData] = useState<any>([]);

  const [addEditObject, setAddEditObject] = useState({
    mnvaddressunitid: 0,
    Region: "",
    Store: "",
    Address: "",
    AccessTime: "",
    ConditionNote: "",
    PricePerSQFT: 0,
    InsuranceCoverage: 0,
    InsuranceCoverageNote: "",
    ObjectStatus: 0,
  });

  useEffect(() => {
    MNVAddressUnitGetCompleteGridDataCustom();
  }, []);

  function MNVAddressUnitGetCompleteGridDataCustom() {
    setIsAnimation(true);
    let object = {} as any;
    object.recordsperpage = 1000;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVAddressUnit/MNVAddressUnitGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          setAddressUnit(l_oResponse[0]);
          setTotalData(l_oResponse[2]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    const {
      Region,
      Store,
      Address,
      AccessTime,
      ConditionNote,
      PricePerSQFT,
      InsuranceCoverage,
      InsuranceCoverageNote,
    } = addEditObject;

    let IsOkay = true;
    let Message = "";

    if (!Region) {
      Message = "Region is required";
    } else if (!Store) {
      Message = "Store is required";
    } else if (!Address) {
      Message = "Address is required";
    } else if (
      isAddNew !== 1 &&
      (AccessTime === null || AccessTime === undefined)
    ) {
      Message = "Insurance Coverage is required";
    }
    // else if (isAddNew !== 1 && (ConditionNote === null || ConditionNote === undefined)) {
    //   Message = "Insurance Coverage is required";
    // }
    else if (!PricePerSQFT) {
      Message = "Price is required";
    } else if (
      isAddNew !== 1 &&
      (InsuranceCoverage === null || InsuranceCoverage === undefined)
    ) {
      Message = "Insurance Coverage is required";
    }
    // else if (isAddNew !== 1 && (InsuranceCoverageNote === null || InsuranceCoverageNote === undefined)) {
    //   Message = "Insurance Coverage is required";
    // }

    if (Message) {
      IsOkay = false;

      showErrorMessage(Message);
    } else {
      MNVAddressUnitSaveCustom();
    }
  }

  function MNVAddressUnitSaveCustom() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvaddressunitid = addEditObject.mnvaddressunitid;
    object.region = addEditObject.Region;
    object.store = addEditObject.Store;
    object.address = addEditObject.Address;
    object.accesstime = addEditObject.AccessTime;
    object.conditionnote = addEditObject.ConditionNote;
    object.pricepersqft = addEditObject.PricePerSQFT;
    object.NewPricePerSQFT = 0;
    object.insurancecoverage = addEditObject.InsuranceCoverage;
    object.insurancecoveragenote = addEditObject.InsuranceCoverageNote;
    object.ptorderby = -1;
    object.objectstatus = addEditObject.ObjectStatus;
    object.extratextfield1 = "";

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVAddressUnit/MNVAddressUnitSaveCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          setIsAddNew(0);
          MNVAddressUnitGetCompleteGridDataCustom();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function MNVAddressUnitDeleteRecordCustom(mnvaddressunitid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvaddressunitid = mnvaddressunitid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVAddressUnit/MNVAddressUnitDeleteRecordCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          // console.log(l_response);
          MNVAddressUnitGetCompleteGridDataCustom();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        MNVAddressUnitDeleteRecordCustom(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {isAddNew == 0 && (
        <>
          <>
            <div className="flex-d justify-end mb-10">
              <div className="flex-daj flex-gap10">
                <div className="flex-da flex-gap10">
                  {totalData && totalData.length > 0 && (
                    <>
                      <div className="data-boxes">
                        <span className="data-txt">Max Insurance:</span>
                        <span>
                          £
                          {totalData[0].MaxInsurance?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>

                      <div className="data-boxes">
                        <span className="data-txt"> Used Insurance:</span>
                        <span>
                          £
                          {totalData[0].UsedInsurance?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                      <div className="data-boxes">
                        <span className="data-txt">Available Insurance:</span>
                        <span>
                          £
                          {totalData[0].AvailableInsurance?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                    </>
                  )}
                </div>
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => {
                      setAddEditObject({
                        mnvaddressunitid: 0,
                        Region: "",
                        Store: "",
                        Address: "",
                        AccessTime: "",
                        ConditionNote: "",
                        PricePerSQFT: 0,
                        InsuranceCoverage: 0,
                        InsuranceCoverageNote: "",
                        ObjectStatus: 1,
                      });
                      setIsAddNew(1);
                    }}
                  >
                    Add New
                  </a>
                </div>
                <a
                  className="btn-primary flex-daj btn-grid"
                  title="Export"
                  onClick={() =>
                    DownloadClientsDataInExcel(
                      "tblemployeebandd",
                      "Address Unit"
                    )
                  }
                >
                  <img src="images/export.svg" width="18" height="18" />
                </a>
              </div>
            </div>
            <div className="flow-auto-sm">
              <table className="reuse-table" id="tblemployeebandd">
                <thead>
                  <tr>
                    <th>Region</th>
                    <th>Store</th>
                    <th>Address</th>
                    <th>Access Time</th>
                    <th>Is it good / issues</th>
                    <th>Price</th>
                    {/* <th>New Price</th> */}
                    <th>Insurance coverage</th>
                    <th>Insurance coverage Note</th>
                    <th>Current Insurance</th>
                    <th>Is Active</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {addressunitData &&
                    addressunitData.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <tr key={index}>
                          <td>{item.Region}</td>
                          <td>{item.Store}</td>
                          <td>{item.Address}</td>
                          <td>{item.AccessTime}</td>
                          <td>{item.ConditionNote}</td>
                          <td className="text-right">
                            £
                            {item.PricePerSQFT?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          {/* <td className="text-right">
                          £{item.NewPricePerSQFT?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td> */}
                          <td className="text-right">
                            £
                            {item.InsuranceCoverage?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            })}
                          </td>
                          <td>{item.InsuranceCoverageNote}</td>
                          <td className="text-right">
                            £
                            {item.Current?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            })}
                          </td>
                          <td>{item.ObjectStatus === 1 ? "Yes" : "No"}</td>
                          <td>
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setAddEditObject({
                                    mnvaddressunitid: item.MNVAddressUnitID,
                                    Region: item.Region,
                                    Store: item.Store,
                                    Address: item.Address,
                                    AccessTime: item.AccessTime,
                                    ConditionNote: item.ConditionNote,
                                    PricePerSQFT: item.PricePerSQFT,
                                    InsuranceCoverage: item.InsuranceCoverage,
                                    InsuranceCoverageNote:
                                      item.InsuranceCoverageNote,
                                    ObjectStatus: item.ObjectStatus ?? 1,
                                  });
                                  setIsAddNew(2);
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MNVAddressUnitID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-1111 gap-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Region:</span>
                <input
                  className="input-field w-100"
                  placeholder="Region"
                  type="text"
                  value={addEditObject.Region}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Region: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Store:</span>
                <input
                  className="input-field w-100"
                  placeholder="Store"
                  type="text"
                  value={addEditObject.Store}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Store: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Address:</span>
                <textarea
                  className="input-field w-100"
                  placeholder="Address"
                  rows={3}
                  value={addEditObject.Address}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Address: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Access Time:
                </span>
                <textarea
                  className="input-field w-100"
                  placeholder="Access Time"
                  rows={3}
                  value={addEditObject.AccessTime}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      AccessTime: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Is it good/issues:
                </span>
                <textarea
                  className="input-field w-100"
                  placeholder="Is it good/issues"
                  rows={2}
                  value={addEditObject.ConditionNote}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ConditionNote: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Price:</span>
                <input
                  className="input-field w-100"
                  placeholder="Price"
                  type="number"
                  value={addEditObject.PricePerSQFT}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PricePerSQFT: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Insurance Coverage:
                </span>
                <input
                  className="input-field w-100"
                  placeholder="Insurance Coverage"
                  type="number"
                  value={addEditObject.InsuranceCoverage}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      InsuranceCoverage: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Insurance Coverage Note:
                </span>
                <textarea
                  className="input-field w-100"
                  placeholder="Insurance Coverage Note"
                  rows={2}
                  value={addEditObject.InsuranceCoverageNote}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      InsuranceCoverageNote: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Active:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.ObjectStatus === 1}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ObjectStatus: e.target.checked ? 1 : 0,
                    }))
                  }
                />
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default AddressUnit;
